import { AppWebSocketManager } from '@/shared/features/websockets/classes/AppWebSocketManager';
import { MESSENGER_CONFIG } from '@/config/messenger';

export const ws = new AppWebSocketManager();
ws.init();
ws.addConnection(MESSENGER_CONFIG.websockets.ticket);
